import { Rating } from 'react-simple-star-rating'

export default function TutorProfileRating({tutorProfile, showCount = true, size=25}) {
  return (
    <>
      <Rating initialValue={tutorProfile.averageClientRating} readonly allowHalfIcon size={size} />
      {showCount &&
        <em className="small">
          ({tutorProfile.tutorReviewsCount} reviews)
        </em>
      }
    </>
  )
}
